<template>
  <div class="u-wrap">
    <div class="heard">
        <input placeholder="请输入要搜索的内容" v-model="keyword" class="input" />
        <div class="u-btn" @click="clickSearch">搜索</div>
    </div>
    <div class="u-content-wrap">
      <van-empty v-if="!loading&&dataList.length == 0" style="width: 100%;" description="暂无数据" />
      <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" offset="20" :finished="finished" finished-text="" @load="onLoad">
          <div style="width: 100vw;height:calc(100vh -50px)">
           <van-cell v-for="(item, i) in dataList" :key="i" :title="item.sxmc" is-link @click="clickItem(item)" />
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import fzsbCard from '@/views/common/fzsb-card.vue'
import { getAction, postAction, postParam } from '@/api/manage'
import { matchType } from '@/utils/util'

export default {
  components: {
    fzsbCard,
  },
  data() {
    return {
      dataList: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 0,
      code: '',
      keyword:'',
      
    }
  },
  created() {
    this.code =  this.$route.query.code;
    this.onRefresh()
  },
  computed: {},
  methods: {
    clickSearch(){
      this.onRefresh()
    },
    getData() {
      let params = { pageNo: this.pageNo, sxlx: this.code,sxmc:this.keyword,  pageSize:'20', }
      getAction('/zhshj/ggfwbszn/page', params).then((res) => {
        if (res.success) {
          if (this.refreshing) {
            this.dataList = []
            this.refreshing = false
          }
          let list = res.result.records
          this.convert(list)
          this.dataList = this.dataList.concat(list)
          this.loading = false
          if (res.result.pages <= this.pageNo) {
            this.finished = true
          }
        }
      })
    },
    onLoad() {
      this.pageNo++
      this.getData()
    },
    clickItem(item) {
      this.$router.push({
        path: '/gzfw/bszn-view',
        query: {id:item.id},
      })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.pageNo = 0
      this.refreshing = true
      this.onLoad()
    },
    convert(list) {
      var newList = list.map((val) => {
        var imgList = []
        var videoList = []
        var audioList = []
        if (val.fj) {
          let arr = val.fj.split(',')
          for (let item of arr) {
            if (matchType(item) == 'image') {
              imgList.push(item)
            } else if (matchType(item) == 'video') {
              videoList.push(item)
            } else if (matchType(item) == 'radio') {
              audioList.push(item)
            }
          }
        }
        val.imgList = imgList
        val.videoList = videoList
        val.audioList = audioList
        return val
      })
      return newList
    },
  },
}
</script>

<style lang="less" scoped>
*{
  box-sizing: border-box;
}
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: 46px;
  background-color: #f5f5f5;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  .u-btn {
    background-color: #3e78f7;
    color: #fff;
    font-size: 14px;
    padding: 2px 12px;
    line-height: 26px;
    margin-left: 12px;
    border-radius: 4px;
    flex-shrink: 0;
  }

  .input {
    flex: 1;
    height: 30px;
    line-height: 30px;
    border: 1px solid #ededed;
    padding-left: 8px;
    font-size: 14px;
  }
}

.u-content-wrap {
  flex: 1;
  display: flex;
}
</style>
